import usePaginatedList, {
  DATE_FILTERS,
  buildPaginatedListUrl,
  parseNextUrl,
} from "api/hooks/shared/paginatedList";

export { DATE_FILTERS, parseNextUrl };

export const buildBillingListUrl = (path, {
  business_branch_id,
  dateFilter,
  startDate,
  endDate,
  page,
  pageSize,
  search = "False",
  includeSearch = true,
}) => buildPaginatedListUrl(path, {
  branchId: business_branch_id,
  branchParam: "business_branch_id",
  dateFilter,
  startDate,
  endDate,
  page,
  pageSize,
  extraParams: includeSearch ? { search } : {},
});

const usePaginatedBillingList = ({
  path,
  business_branch_id,
  pageSize = 50,
  includeSearch = true,
  externalRefresh,
}) => usePaginatedList({
  path,
  branchId: business_branch_id,
  branchParam: "business_branch_id",
  pageSize,
  extraParams: includeSearch ? { search: "False" } : {},
  externalRefresh,
});

export default usePaginatedBillingList;
